<template>
  <div class="sub-container" v-show="!loading">
    <template v-if="liveStreamList.length + notLiveList.length != 0">
      <div class="top-tag-switch">
        <div class="switch">
          <div class="tag" :class="{active:activeTag == key}" v-for="(node,key) in tabMap" @click="activeTag = key">{{node.name}}</div>
        </div>
      </div>
      <div class="live-line" v-if="activeTag == 'live'">
        <div class="video-item-box" v-for="v in liveStreamList">
          <div class="video-item">
            <div class="video-container" @click="goVideo(v.videoId)">
              <div class="video-thumbnail-wrapper" :style="{backgroundImage: `url(${v.thumbnailMedium})`}">
                <div class="video-info">
                  <div class="user-info">
                    <span class="user-avatar" :style="{backgroundImage: `url(${v.streamerAvatar})`}"></span><span class="user-name">{{v.streamer}}</span>
                  </div>
                  <div class="watch-num">
                    <i class="icon icon-watch-people-yellow"></i>{{ v.viewCount | readableNum }}
                  </div>
                </div>
              </div>
              <h3 class="video-title">{{ v.title }}</h3>
            </div>
          </div>
          
        </div>
        <div class="list-bottom-ctrl">
          <span class="more" @click="getFollowList(true)" v-if="liveStreamShowMore">
            <span>{{getDict(89)}}</span>
          </span>
        </div>
      </div>
      <div class="not-live-line" v-if="activeTag == 'noLive'">
        <div class="video-item-box" v-for="v in notLiveList">
          <div class="video-item ">
            <div class="not-live-container">
              <div class="user-img">
                <span class="user-avatar" :style="{backgroundImage: `url(${v.streamerAvatar})`}"></span>
              </div>
              <div class="user-info">
                <span class="user-name">{{v.streamer}}</span>
                <span class="user-status">
                  <i class="icon icon-coffee"></i>
                  <span>{{getDict(90)}}</span>
                </span>
                <span class="user-view-count">
                  <i class="icon icon-fire"></i>
                  <span>{{ v.viewCount | readableNum }}</span>
                </span>
              </div>
            </div>
            
          </div>
          
        </div>
        <div class="list-bottom-ctrl">
          <span class="more" @click="getFollowList(false)" v-if="notLiveShowMore">
            <span>{{getDict(89)}}</span>
          </span>
        </div>
      </div>
    </template>
    <div class="no-follow" v-if="liveStreamList.length + notLiveList.length == 0">
      <div class="img">
        <i class="icon icon-no-gamble"></i>
      </div>
      <div class="tips">
        <span>{{getDict(86)}}</span>
      </div>
    </div>
  </div>
</template>

<script>
  import { getDict, axios, getPageLevelMixin, webSocket } from '../../common'
  import { mapState, mapGetters } from 'vuex'
  import alert from '../../components/alert'
  import ScrollBox from '../../components/scrollBox'

  export default {
    mixins:[],
    props:{
    },
    data(){
      return {
        loading:true,
        tabMap:{
          live:{
            name:getDict(91),
          },
          noLive:{
            name:getDict(92),
          },
        },
        activeTag:"live",
        liveStreamShowMore:true,
        notLiveShowMore:true,
        liveStreamList:[/*
          {
            "platform": "youtube",
            "isFetchedFromStreamer": false,
            "isBlocked": false,
            "videoId": "8Z7cv2YdG5Y",
            "liveBroadcastContent": "none",
            "liveBroadcastContentOrder": 4,
            "title": "すまない。俺は強くなりすぎてしまった。【荒野行動】",
            "channelId": "UCLiQ--EXgzUV03q5jKQYWcw",
            "thumbnailSmall": "https://i.ytimg.com/vi/8Z7cv2YdG5Y/default.jpg",
            "thumbnailMedium": "https://i.ytimg.com/vi/8Z7cv2YdG5Y/mqdefault.jpg",
            "thumbnailLarge": "https://i.ytimg.com/vi/8Z7cv2YdG5Y/hqdefault.jpg",
            "streamer": "o-228おにや",
            "viewCount": 126185,
            "streamerAvatar": "https://yt3.ggpht.com/a/AGF-l79yCjY3ljOGCVnMhIX-Ph7F5v-3kzVfvwvL6g=s88-mo-c-c0xffffffff-rj-k-no",
            "isTop": 0
          },
          {
            "platform": "youtube",
            "isFetchedFromStreamer": false,
            "isBlocked": false,
            "videoId": "JrNjxLjodcU",
            "liveBroadcastContent": "none",
            "liveBroadcastContentOrder": 4,
            "title": "【実写】おれの手元動画見たい？？？",
            "channelId": "UCx9fP6bPm6buX5Ygpd_mO9w",
            "thumbnailSmall": "https://i.ytimg.com/vi/JrNjxLjodcU/default.jpg",
            "thumbnailMedium": "https://i.ytimg.com/vi/JrNjxLjodcU/mqdefault.jpg",
            "thumbnailLarge": "https://i.ytimg.com/vi/JrNjxLjodcU/hqdefault.jpg",
            "streamer": "金花【きんばな】",
            "viewCount": 374401,
            "streamerAvatar": "https://yt3.ggpht.com/a/AGF-l78vezUgIQkyNV2vXIggvyN56HjTEbeVDgWwZw=s88-mo-c-c0xffffffff-rj-k-no",
            "isTop": 0
          },
          {
            "platform": "youtube",
            "isFetchedFromStreamer": false,
            "isBlocked": false,
            "videoId": "Rnm2DzV5BYk",
            "liveBroadcastContent": "none",
            "liveBroadcastContentOrder": 4,
            "title": "【荒野行動】こんなキル数見たことある？",
            "channelId": "UCbdmvBJuphbyB2_LjBMW3MA",
            "thumbnailSmall": "https://i.ytimg.com/vi/Rnm2DzV5BYk/default.jpg",
            "thumbnailMedium": "https://i.ytimg.com/vi/Rnm2DzV5BYk/mqdefault.jpg",
            "thumbnailLarge": "https://i.ytimg.com/vi/Rnm2DzV5BYk/hqdefault.jpg",
            "streamer": "ふぇいたん",
            "viewCount": 157756,
            "streamerAvatar": "https://yt3.ggpht.com/a/AGF-l79DXL-6272ioFp8iLic0_IES7DNo29MK7rLuQ=s88-mo-c-c0xffffffff-rj-k-no",
            "isTop": 0
          },
          {
            "platform": "youtube",
            "isFetchedFromStreamer": false,
            "isBlocked": false,
            "videoId": "Rnm2DzV5BYk",
            "liveBroadcastContent": "none",
            "liveBroadcastContentOrder": 4,
            "title": "【荒野行動】こんなキル数見たことある？",
            "channelId": "UCbdmvBJuphbyB2_LjBMW3MA",
            "thumbnailSmall": "https://i.ytimg.com/vi/Rnm2DzV5BYk/default.jpg",
            "thumbnailMedium": "https://i.ytimg.com/vi/Rnm2DzV5BYk/mqdefault.jpg",
            "thumbnailLarge": "https://i.ytimg.com/vi/Rnm2DzV5BYk/hqdefault.jpg",
            "streamer": "ふぇいたん",
            "viewCount": 157756,
            "streamerAvatar": "https://yt3.ggpht.com/a/AGF-l79DXL-6272ioFp8iLic0_IES7DNo29MK7rLuQ=s88-mo-c-c0xffffffff-rj-k-no",
            "isTop": 0
          },

          {
            "platform": "youtube",
            "isFetchedFromStreamer": false,
            "isBlocked": false,
            "videoId": "8Z7cv2YdG5Y",
            "liveBroadcastContent": "none",
            "liveBroadcastContentOrder": 4,
            "title": "すまない。俺は強くなりすぎてしまった。【荒野行動】",
            "channelId": "UCLiQ--EXgzUV03q5jKQYWcw",
            "thumbnailSmall": "https://i.ytimg.com/vi/8Z7cv2YdG5Y/default.jpg",
            "thumbnailMedium": "https://i.ytimg.com/vi/8Z7cv2YdG5Y/mqdefault.jpg",
            "thumbnailLarge": "https://i.ytimg.com/vi/8Z7cv2YdG5Y/hqdefault.jpg",
            "streamer": "o-228おにや",
            "viewCount": 126185,
            "streamerAvatar": "https://yt3.ggpht.com/a/AGF-l79yCjY3ljOGCVnMhIX-Ph7F5v-3kzVfvwvL6g=s88-mo-c-c0xffffffff-rj-k-no",
            "isTop": 0
          },
          {
            "platform": "youtube",
            "isFetchedFromStreamer": false,
            "isBlocked": false,
            "videoId": "JrNjxLjodcU",
            "liveBroadcastContent": "none",
            "liveBroadcastContentOrder": 4,
            "title": "【実写】おれの手元動画見たい？？？",
            "channelId": "UCx9fP6bPm6buX5Ygpd_mO9w",
            "thumbnailSmall": "https://i.ytimg.com/vi/JrNjxLjodcU/default.jpg",
            "thumbnailMedium": "https://i.ytimg.com/vi/JrNjxLjodcU/mqdefault.jpg",
            "thumbnailLarge": "https://i.ytimg.com/vi/JrNjxLjodcU/hqdefault.jpg",
            "streamer": "金花【きんばな】",
            "viewCount": 374401,
            "streamerAvatar": "https://yt3.ggpht.com/a/AGF-l78vezUgIQkyNV2vXIggvyN56HjTEbeVDgWwZw=s88-mo-c-c0xffffffff-rj-k-no",
            "isTop": 0
          },
          {
            "platform": "youtube",
            "isFetchedFromStreamer": false,
            "isBlocked": false,
            "videoId": "Rnm2DzV5BYk",
            "liveBroadcastContent": "none",
            "liveBroadcastContentOrder": 4,
            "title": "【荒野行動】こんなキル数見たことある？",
            "channelId": "UCbdmvBJuphbyB2_LjBMW3MA",
            "thumbnailSmall": "https://i.ytimg.com/vi/Rnm2DzV5BYk/default.jpg",
            "thumbnailMedium": "https://i.ytimg.com/vi/Rnm2DzV5BYk/mqdefault.jpg",
            "thumbnailLarge": "https://i.ytimg.com/vi/Rnm2DzV5BYk/hqdefault.jpg",
            "streamer": "ふぇいたん",
            "viewCount": 157756,
            "streamerAvatar": "https://yt3.ggpht.com/a/AGF-l79DXL-6272ioFp8iLic0_IES7DNo29MK7rLuQ=s88-mo-c-c0xffffffff-rj-k-no",
            "isTop": 0
          },
          {
            "platform": "youtube",
            "isFetchedFromStreamer": false,
            "isBlocked": false,
            "videoId": "Rnm2DzV5BYk",
            "liveBroadcastContent": "none",
            "liveBroadcastContentOrder": 4,
            "title": "【荒野行動】こんなキル数見たことある？",
            "channelId": "UCbdmvBJuphbyB2_LjBMW3MA",
            "thumbnailSmall": "https://i.ytimg.com/vi/Rnm2DzV5BYk/default.jpg",
            "thumbnailMedium": "https://i.ytimg.com/vi/Rnm2DzV5BYk/mqdefault.jpg",
            "thumbnailLarge": "https://i.ytimg.com/vi/Rnm2DzV5BYk/hqdefault.jpg",
            "streamer": "ふぇいたん",
            "viewCount": 157756,
            "streamerAvatar": "https://yt3.ggpht.com/a/AGF-l79DXL-6272ioFp8iLic0_IES7DNo29MK7rLuQ=s88-mo-c-c0xffffffff-rj-k-no",
            "isTop": 0
          },
          {
            "platform": "youtube",
            "isFetchedFromStreamer": false,
            "isBlocked": false,
            "videoId": "8Z7cv2YdG5Y",
            "liveBroadcastContent": "none",
            "liveBroadcastContentOrder": 4,
            "title": "すまない。俺は強くなりすぎてしまった。【荒野行動】",
            "channelId": "UCLiQ--EXgzUV03q5jKQYWcw",
            "thumbnailSmall": "https://i.ytimg.com/vi/8Z7cv2YdG5Y/default.jpg",
            "thumbnailMedium": "https://i.ytimg.com/vi/8Z7cv2YdG5Y/mqdefault.jpg",
            "thumbnailLarge": "https://i.ytimg.com/vi/8Z7cv2YdG5Y/hqdefault.jpg",
            "streamer": "o-228おにや",
            "viewCount": 126185,
            "streamerAvatar": "https://yt3.ggpht.com/a/AGF-l79yCjY3ljOGCVnMhIX-Ph7F5v-3kzVfvwvL6g=s88-mo-c-c0xffffffff-rj-k-no",
            "isTop": 0
          },
          {
            "platform": "youtube",
            "isFetchedFromStreamer": false,
            "isBlocked": false,
            "videoId": "JrNjxLjodcU",
            "liveBroadcastContent": "none",
            "liveBroadcastContentOrder": 4,
            "title": "【実写】おれの手元動画見たい？？？",
            "channelId": "UCx9fP6bPm6buX5Ygpd_mO9w",
            "thumbnailSmall": "https://i.ytimg.com/vi/JrNjxLjodcU/default.jpg",
            "thumbnailMedium": "https://i.ytimg.com/vi/JrNjxLjodcU/mqdefault.jpg",
            "thumbnailLarge": "https://i.ytimg.com/vi/JrNjxLjodcU/hqdefault.jpg",
            "streamer": "金花【きんばな】",
            "viewCount": 374401,
            "streamerAvatar": "https://yt3.ggpht.com/a/AGF-l78vezUgIQkyNV2vXIggvyN56HjTEbeVDgWwZw=s88-mo-c-c0xffffffff-rj-k-no",
            "isTop": 0
          },
          {
            "platform": "youtube",
            "isFetchedFromStreamer": false,
            "isBlocked": false,
            "videoId": "Rnm2DzV5BYk",
            "liveBroadcastContent": "none",
            "liveBroadcastContentOrder": 4,
            "title": "【荒野行動】こんなキル数見たことある？",
            "channelId": "UCbdmvBJuphbyB2_LjBMW3MA",
            "thumbnailSmall": "https://i.ytimg.com/vi/Rnm2DzV5BYk/default.jpg",
            "thumbnailMedium": "https://i.ytimg.com/vi/Rnm2DzV5BYk/mqdefault.jpg",
            "thumbnailLarge": "https://i.ytimg.com/vi/Rnm2DzV5BYk/hqdefault.jpg",
            "streamer": "ふぇいたん",
            "viewCount": 157756,
            "streamerAvatar": "https://yt3.ggpht.com/a/AGF-l79DXL-6272ioFp8iLic0_IES7DNo29MK7rLuQ=s88-mo-c-c0xffffffff-rj-k-no",
            "isTop": 0
          },
          {
            "platform": "youtube",
            "isFetchedFromStreamer": false,
            "isBlocked": false,
            "videoId": "Rnm2DzV5BYk",
            "liveBroadcastContent": "none",
            "liveBroadcastContentOrder": 4,
            "title": "【荒野行動】こんなキル数見たことある？",
            "channelId": "UCbdmvBJuphbyB2_LjBMW3MA",
            "thumbnailSmall": "https://i.ytimg.com/vi/Rnm2DzV5BYk/default.jpg",
            "thumbnailMedium": "https://i.ytimg.com/vi/Rnm2DzV5BYk/mqdefault.jpg",
            "thumbnailLarge": "https://i.ytimg.com/vi/Rnm2DzV5BYk/hqdefault.jpg",
            "streamer": "ふぇいたん",
            "viewCount": 157756,
            "streamerAvatar": "https://yt3.ggpht.com/a/AGF-l79DXL-6272ioFp8iLic0_IES7DNo29MK7rLuQ=s88-mo-c-c0xffffffff-rj-k-no",
            "isTop": 0
          }
        */],
        liveStreamNext:0,
        notLiveList:[/*
          {
            "platform": "youtube",
            "isFetchedFromStreamer": false,
            "isBlocked": false,
            "videoId": "8Z7cv2YdG5Y",
            "liveBroadcastContent": "none",
            "liveBroadcastContentOrder": 4,
            "title": "すまない。俺は強くなりすぎてしまった。【荒野行動】",
            "channelId": "UCLiQ--EXgzUV03q5jKQYWcw",
            "thumbnailSmall": "https://i.ytimg.com/vi/8Z7cv2YdG5Y/default.jpg",
            "thumbnailMedium": "https://i.ytimg.com/vi/8Z7cv2YdG5Y/mqdefault.jpg",
            "thumbnailLarge": "https://i.ytimg.com/vi/8Z7cv2YdG5Y/hqdefault.jpg",
            "streamer": "o-228おにや",
            "viewCount": 126185,
            "streamerAvatar": "https://yt3.ggpht.com/a/AGF-l79yCjY3ljOGCVnMhIX-Ph7F5v-3kzVfvwvL6g=s88-mo-c-c0xffffffff-rj-k-no",
            "isTop": 0
          },
          {
            "platform": "youtube",
            "isFetchedFromStreamer": false,
            "isBlocked": false,
            "videoId": "JrNjxLjodcU",
            "liveBroadcastContent": "none",
            "liveBroadcastContentOrder": 4,
            "title": "【実写】おれの手元動画見たい？？？",
            "channelId": "UCx9fP6bPm6buX5Ygpd_mO9w",
            "thumbnailSmall": "https://i.ytimg.com/vi/JrNjxLjodcU/default.jpg",
            "thumbnailMedium": "https://i.ytimg.com/vi/JrNjxLjodcU/mqdefault.jpg",
            "thumbnailLarge": "https://i.ytimg.com/vi/JrNjxLjodcU/hqdefault.jpg",
            "streamer": "金花【きんばな】",
            "viewCount": 374401,
            "streamerAvatar": "https://yt3.ggpht.com/a/AGF-l78vezUgIQkyNV2vXIggvyN56HjTEbeVDgWwZw=s88-mo-c-c0xffffffff-rj-k-no",
            "isTop": 0
          },
          {
            "platform": "youtube",
            "isFetchedFromStreamer": false,
            "isBlocked": false,
            "videoId": "Rnm2DzV5BYk",
            "liveBroadcastContent": "none",
            "liveBroadcastContentOrder": 4,
            "title": "【荒野行動】こんなキル数見たことある？",
            "channelId": "UCbdmvBJuphbyB2_LjBMW3MA",
            "thumbnailSmall": "https://i.ytimg.com/vi/Rnm2DzV5BYk/default.jpg",
            "thumbnailMedium": "https://i.ytimg.com/vi/Rnm2DzV5BYk/mqdefault.jpg",
            "thumbnailLarge": "https://i.ytimg.com/vi/Rnm2DzV5BYk/hqdefault.jpg",
            "streamer": "ふぇいたん",
            "viewCount": 157756,
            "streamerAvatar": "https://yt3.ggpht.com/a/AGF-l79DXL-6272ioFp8iLic0_IES7DNo29MK7rLuQ=s88-mo-c-c0xffffffff-rj-k-no",
            "isTop": 0
          },
          {
            "platform": "youtube",
            "isFetchedFromStreamer": false,
            "isBlocked": false,
            "videoId": "Rnm2DzV5BYk",
            "liveBroadcastContent": "none",
            "liveBroadcastContentOrder": 4,
            "title": "【荒野行動】こんなキル数見たことある？",
            "channelId": "UCbdmvBJuphbyB2_LjBMW3MA",
            "thumbnailSmall": "https://i.ytimg.com/vi/Rnm2DzV5BYk/default.jpg",
            "thumbnailMedium": "https://i.ytimg.com/vi/Rnm2DzV5BYk/mqdefault.jpg",
            "thumbnailLarge": "https://i.ytimg.com/vi/Rnm2DzV5BYk/hqdefault.jpg",
            "streamer": "ふぇいたん",
            "viewCount": 157756,
            "streamerAvatar": "https://yt3.ggpht.com/a/AGF-l79DXL-6272ioFp8iLic0_IES7DNo29MK7rLuQ=s88-mo-c-c0xffffffff-rj-k-no",
            "isTop": 0
          },

          {
            "platform": "youtube",
            "isFetchedFromStreamer": false,
            "isBlocked": false,
            "videoId": "8Z7cv2YdG5Y",
            "liveBroadcastContent": "none",
            "liveBroadcastContentOrder": 4,
            "title": "すまない。俺は強くなりすぎてしまった。【荒野行動】",
            "channelId": "UCLiQ--EXgzUV03q5jKQYWcw",
            "thumbnailSmall": "https://i.ytimg.com/vi/8Z7cv2YdG5Y/default.jpg",
            "thumbnailMedium": "https://i.ytimg.com/vi/8Z7cv2YdG5Y/mqdefault.jpg",
            "thumbnailLarge": "https://i.ytimg.com/vi/8Z7cv2YdG5Y/hqdefault.jpg",
            "streamer": "o-228おにや",
            "viewCount": 126185,
            "streamerAvatar": "https://yt3.ggpht.com/a/AGF-l79yCjY3ljOGCVnMhIX-Ph7F5v-3kzVfvwvL6g=s88-mo-c-c0xffffffff-rj-k-no",
            "isTop": 0
          },
          {
            "platform": "youtube",
            "isFetchedFromStreamer": false,
            "isBlocked": false,
            "videoId": "JrNjxLjodcU",
            "liveBroadcastContent": "none",
            "liveBroadcastContentOrder": 4,
            "title": "【実写】おれの手元動画見たい？？？",
            "channelId": "UCx9fP6bPm6buX5Ygpd_mO9w",
            "thumbnailSmall": "https://i.ytimg.com/vi/JrNjxLjodcU/default.jpg",
            "thumbnailMedium": "https://i.ytimg.com/vi/JrNjxLjodcU/mqdefault.jpg",
            "thumbnailLarge": "https://i.ytimg.com/vi/JrNjxLjodcU/hqdefault.jpg",
            "streamer": "金花【きんばな】",
            "viewCount": 374401,
            "streamerAvatar": "https://yt3.ggpht.com/a/AGF-l78vezUgIQkyNV2vXIggvyN56HjTEbeVDgWwZw=s88-mo-c-c0xffffffff-rj-k-no",
            "isTop": 0
          },
          {
            "platform": "youtube",
            "isFetchedFromStreamer": false,
            "isBlocked": false,
            "videoId": "Rnm2DzV5BYk",
            "liveBroadcastContent": "none",
            "liveBroadcastContentOrder": 4,
            "title": "【荒野行動】こんなキル数見たことある？",
            "channelId": "UCbdmvBJuphbyB2_LjBMW3MA",
            "thumbnailSmall": "https://i.ytimg.com/vi/Rnm2DzV5BYk/default.jpg",
            "thumbnailMedium": "https://i.ytimg.com/vi/Rnm2DzV5BYk/mqdefault.jpg",
            "thumbnailLarge": "https://i.ytimg.com/vi/Rnm2DzV5BYk/hqdefault.jpg",
            "streamer": "ふぇいたん",
            "viewCount": 157756,
            "streamerAvatar": "https://yt3.ggpht.com/a/AGF-l79DXL-6272ioFp8iLic0_IES7DNo29MK7rLuQ=s88-mo-c-c0xffffffff-rj-k-no",
            "isTop": 0
          },
          {
            "platform": "youtube",
            "isFetchedFromStreamer": false,
            "isBlocked": false,
            "videoId": "Rnm2DzV5BYk",
            "liveBroadcastContent": "none",
            "liveBroadcastContentOrder": 4,
            "title": "【荒野行動】こんなキル数見たことある？",
            "channelId": "UCbdmvBJuphbyB2_LjBMW3MA",
            "thumbnailSmall": "https://i.ytimg.com/vi/Rnm2DzV5BYk/default.jpg",
            "thumbnailMedium": "https://i.ytimg.com/vi/Rnm2DzV5BYk/mqdefault.jpg",
            "thumbnailLarge": "https://i.ytimg.com/vi/Rnm2DzV5BYk/hqdefault.jpg",
            "streamer": "ふぇいたん",
            "viewCount": 157756,
            "streamerAvatar": "https://yt3.ggpht.com/a/AGF-l79DXL-6272ioFp8iLic0_IES7DNo29MK7rLuQ=s88-mo-c-c0xffffffff-rj-k-no",
            "isTop": 0
          },
          {
            "platform": "youtube",
            "isFetchedFromStreamer": false,
            "isBlocked": false,
            "videoId": "8Z7cv2YdG5Y",
            "liveBroadcastContent": "none",
            "liveBroadcastContentOrder": 4,
            "title": "すまない。俺は強くなりすぎてしまった。【荒野行動】",
            "channelId": "UCLiQ--EXgzUV03q5jKQYWcw",
            "thumbnailSmall": "https://i.ytimg.com/vi/8Z7cv2YdG5Y/default.jpg",
            "thumbnailMedium": "https://i.ytimg.com/vi/8Z7cv2YdG5Y/mqdefault.jpg",
            "thumbnailLarge": "https://i.ytimg.com/vi/8Z7cv2YdG5Y/hqdefault.jpg",
            "streamer": "o-228おにや",
            "viewCount": 126185,
            "streamerAvatar": "https://yt3.ggpht.com/a/AGF-l79yCjY3ljOGCVnMhIX-Ph7F5v-3kzVfvwvL6g=s88-mo-c-c0xffffffff-rj-k-no",
            "isTop": 0
          },
          {
            "platform": "youtube",
            "isFetchedFromStreamer": false,
            "isBlocked": false,
            "videoId": "JrNjxLjodcU",
            "liveBroadcastContent": "none",
            "liveBroadcastContentOrder": 4,
            "title": "【実写】おれの手元動画見たい？？？",
            "channelId": "UCx9fP6bPm6buX5Ygpd_mO9w",
            "thumbnailSmall": "https://i.ytimg.com/vi/JrNjxLjodcU/default.jpg",
            "thumbnailMedium": "https://i.ytimg.com/vi/JrNjxLjodcU/mqdefault.jpg",
            "thumbnailLarge": "https://i.ytimg.com/vi/JrNjxLjodcU/hqdefault.jpg",
            "streamer": "金花【きんばな】",
            "viewCount": 374401,
            "streamerAvatar": "https://yt3.ggpht.com/a/AGF-l78vezUgIQkyNV2vXIggvyN56HjTEbeVDgWwZw=s88-mo-c-c0xffffffff-rj-k-no",
            "isTop": 0
          },
          {
            "platform": "youtube",
            "isFetchedFromStreamer": false,
            "isBlocked": false,
            "videoId": "Rnm2DzV5BYk",
            "liveBroadcastContent": "none",
            "liveBroadcastContentOrder": 4,
            "title": "【荒野行動】こんなキル数見たことある？",
            "channelId": "UCbdmvBJuphbyB2_LjBMW3MA",
            "thumbnailSmall": "https://i.ytimg.com/vi/Rnm2DzV5BYk/default.jpg",
            "thumbnailMedium": "https://i.ytimg.com/vi/Rnm2DzV5BYk/mqdefault.jpg",
            "thumbnailLarge": "https://i.ytimg.com/vi/Rnm2DzV5BYk/hqdefault.jpg",
            "streamer": "ふぇいたん",
            "viewCount": 157756,
            "streamerAvatar": "https://yt3.ggpht.com/a/AGF-l79DXL-6272ioFp8iLic0_IES7DNo29MK7rLuQ=s88-mo-c-c0xffffffff-rj-k-no",
            "isTop": 0
          },
          {
            "platform": "youtube",
            "isFetchedFromStreamer": false,
            "isBlocked": false,
            "videoId": "Rnm2DzV5BYk",
            "liveBroadcastContent": "none",
            "liveBroadcastContentOrder": 4,
            "title": "【荒野行動】こんなキル数見たことある？",
            "channelId": "UCbdmvBJuphbyB2_LjBMW3MA",
            "thumbnailSmall": "https://i.ytimg.com/vi/Rnm2DzV5BYk/default.jpg",
            "thumbnailMedium": "https://i.ytimg.com/vi/Rnm2DzV5BYk/mqdefault.jpg",
            "thumbnailLarge": "https://i.ytimg.com/vi/Rnm2DzV5BYk/hqdefault.jpg",
            "streamer": "ふぇいたん",
            "viewCount": 157756,
            "streamerAvatar": "https://yt3.ggpht.com/a/AGF-l79DXL-6272ioFp8iLic0_IES7DNo29MK7rLuQ=s88-mo-c-c0xffffffff-rj-k-no",
            "isTop": 0
          }
        */],
        notLiveNext:0,
      }
    },
    computed:{
      /*liveStreamList(){
        return this.streamList.filter(node=>{
          return true;
          return ['live','upComing','upcoming'].includes(node.liveBroadcastContent);
        });
      },
      notLiveList(){
        
        return this.streamList.filter(node=>{
          return true;
          return !['live','upComing','upcoming'].includes(node.liveBroadcastContent);
        });
      }*/
    },
    watch:{
    },
    methods: {
      getDict,
      //=================
      goVideo(id){
        this.$router.push(`/liveBroadcast/${id}`);
      },
      async getFollowList(live){
        const limit = 100;
        let resData = await webSocket.get('/user/follow/find',{
          limit,
          cursor: live?this.liveStreamNext:this.notLiveNext,
          living:live,
        });
        if(resData.channel_infos && resData.channel_infos.length){
          if(live){
            this.liveStreamList = this.liveStreamList.concat(resData.channel_infos);
            this.liveStreamNext = resData.next_cursor;
            if(resData.channel_infos.length < limit){
              this.liveStreamShowMore = false;
            }
          }else{
            this.notLiveList = this.notLiveList.concat(resData.channel_infos);
            this.notLiveNext = resData.next_cursor;
            if(resData.channel_infos.length < limit){
              this.notLiveShowMore = false;
            }
          }
        }else{
          if(live){
            this.liveStreamShowMore = false;
          }else{
            this.notLiveShowMore = false;
          }
        }
        
        // this.streamList = resData.channel_infos || [];
      }
    },
    components: {
      alert,ScrollBox,
    },
    mounted(){
      
    },
    created(){
      let getDate = async ()=>{
        await this.getFollowList(true);
        await this.getFollowList(false);
      }
      
      getDate().then(()=>{
        this.loading = false;
      })
      
    }
  }
</script>

<style lang="scss" scoped>
  .sub-container{
    width: 100%;
    height: 100%;
    padding: 0 0.4rem;
    display: flex;
    flex-direction: column;
    // justify-content: space-between;
    /* .top{
      $font-size: 0.3rem;
      $height: 0.5rem;
      font-size: $font-size;
      // background-color: rgba(0,0,0,0.4);
      height: $height;
      display: flex;
      justify-content: space-between;
      div{
        display: inline-block;
        height: $height;
        line-height: $height;
      }

      .block-name{
        // font-weight: 600;
        $font-size: 0.19rem;
        line-height: $font-size*1.5;
        flex: 1;
        .icon{
          vertical-align: text-bottom;
        }
        .name{
          font-size: $font-size;
          vertical-align: middle;
          color: #ffc44f
        }
        .video-num{
          display: inline-block;
          margin-left: 0.1rem;
          width: 0.5rem;
          font-size: $font-size * 0.9;
          line-height: $font-size * 1.3;
          vertical-align: middle;
          background-color: #c84646;
          color: #fff;
          text-align: center;
          border-radius:1rem;
        }
      }

      .next-video{
        font-size: $font-size * 0.9;
        line-height: $height;

        .icon{
          margin-left: 0.05rem;

          overflow: hidden;

          &:after{
            display: block;
            content: '';
            width: 100%;
            height: 100%;
            background: inherit;
            transform: translateX(-50px);
            filter: drop-shadow(50px 0 0 #ffc44f);
          }
        }
        
      }
      
    } */
    .top-tag-switch{
      margin-top: 0.4rem;
      .switch{
        $color:#ffc44f;
        $color2:#44474c; 
        display: inline-block;
        font-size: 0.2rem;
        border:1px solid #{$color};
        color: $color;


        .tag{
          display: inline-block;
          padding: 0.05rem 0.2rem;
          background-color: $color2;

          &.active{
            background-color: $color;
            color: $color2;
          }
        }
      }
    }

    .live-line,.not-live-line{
      margin: 0.2rem 0 0;


      width: 100%;
      height: 100%;
      overflow: auto;
      padding-right: 0.1rem;
      // display: flex;
      // flex-wrap:wrap;
      // justify-content: space-between;


      &::-webkit-scrollbar {/*滚动条整体样式*/
        width: 0.04rem;     /*高宽分别对应横竖滚动条的尺寸*/
        height: 1px;
      }
      &::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
        background: #e9a500;
      }
      &::-webkit-scrollbar-track {/*滚动条里面轨道*/
        background: #aaa;
      }

      .video-item-box{
        width: 33.3%;
        display: inline-block;
        padding-bottom: 0.2rem;

        &:nth-child(3n+1):nth-last-child(-n+3),&:nth-child(3n+1):nth-last-child(-n+3)~div{
          padding-bottom: 0rem;
        }
        .video-item{
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
        }

        
      }

      

    }

    .live-line{
      // height: 50%;
      // width: 100%;
      // margin: 0.2rem 0 0;
      
      // background-color: rgba(0,0,0,0.4);
      .video-container{
        $width: 2.8rem;
        display: inline-block;
        width: $width;
        .video-thumbnail-wrapper{
          width: 2.8rem;
          height: 1.42rem;
          background: rgba(255, 255, 255, .4) no-repeat center center;
          // background-size: cover;
          background-size: 100% auto;
          position: relative;
          // border: .03rem solid #ffd559;
          .video-info{
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            font-size: .14rem;
            height: .28rem;
            background: rgba(0, 0, 0, .7);
            color: #ffd559;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 .18rem;
          }
          .user-info{
            .user-avatar{
              display: inline-block;
              background: no-repeat center center;
              background-size: 100% 100%;
              width: .24rem;
              height: .24rem;
              border-radius: 50%;
              margin-right: .04rem;
              border: .01rem solid #ecbc5f;
              vertical-align: -.04rem;
            }
            .user-name{
              display: inline-block;
              max-width: 1.2rem;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
            }
          }
        }
        .video-title{
          color: #fff;
          font-size: .18rem;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          margin-top: .03rem;
          line-height: .24rem;
        }
        
      }

    }

    .not-live-line{
      // height: 50%;
      // width: 100%;
      
      // background-color: rgba(0,0,0,0.4);
      .not-live-container{
        $width: 2.8rem;
        $height: 1.2rem;
        $padding:  0.1rem;
        flex-shrink: 0;
        display: flex;
        width: $width;
        height: $height;
        background-color: #fff;
        border-radius: 0.1rem;
        padding: $padding;


        background-image: url(./imgs/follow-video-bg.png);
        background-repeat: no-repeat;
        background-position: right;
        background-size: auto 100% ; 

        .user-img{
          $icon-size:$height - $padding * 2;
          display: inline-block;
          height: $icon-size;
          width: $icon-size;
          .user-avatar{
            display: inline-block;
            background: no-repeat center center;
            background-size: 100% 100%;
            width: $icon-size;
            height: $icon-size;
            border-radius: 50%;
          }
        }

        .user-info{
          width: $width - $height - $padding;
          display: inline-block;
          margin-left: $padding;
          display: flex;
          justify-content: space-around;
          flex-direction: column;
          $font-size: 0.2rem;
          font-size: $font-size;
          .user-name{
            color: #000;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            margin-bottom: 0.1rem;
            font-weight: 600;
          }
          .user-status{
            color:#656970;
          }
          .user-view-count{
            color:#cc9900;
          }
        }

        
        
      }

    }

    .list-bottom-ctrl{
      $font-size:0.2rem;
      // margin-top: 0.1rem;
      padding: 0.1rem 0;
      font-size: $font-size;
      // width: 100%;
      text-align:center;
      $box-hight:$font-size *2;
      .more{
        display: inline-block;
        height: $box-hight;
        width: 1.2rem;
        line-height: $box-hight;
        background-color: #333;
        border-radius: 0.07rem;
        .icon{
          vertical-align: middle;
        }
      }
    }
    .no-follow{
      text-align: center;
      display: flex;
      flex-direction: column;
      height: 90%;
      justify-content: center;
      .img{
        .icon{
          margin: 0;
        }
      }
      .tips{
        margin-top: 0.1rem;
        font-size: 0.25rem;
      }
    }
  }


</style>
